
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"6","cy":"12","r":"1.5"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"1.5"}}),_c('circle',{attrs:{"cx":"18","cy":"12","r":"1.5"}})])
          )
        }
      }
    